const REGIONS = {
  'northern-rivers': {
    id: 'northern-rivers',
    label: 'Northern Rivers',
    state: 'NSW',
    mapCentre: { lat: -28.65, lng: 153.55, zoom: 10 },
    stripeProductFamily: 'pro-nr',
  },
  'mid-north-coast': {
    id: 'mid-north-coast',
    label: 'Mid North Coast',
    state: 'NSW',
    mapCentre: { lat: -30.3, lng: 153.05, zoom: 9 },
    stripeProductFamily: 'pro-mnc',
  },
  brisbane: {
    id: 'brisbane',
    label: 'Brisbane',
    state: 'QLD',
    mapCentre: { lat: -27.47, lng: 153.02, zoom: 11 },
    stripeProductFamily: 'pro-bne',
  },
};

const COUNCILS = [
  {
    name: 'Byron Shire Council',
    shortName: 'Byron',
    selectorLabel: 'Byron Shire',
    state: 'NSW',
    region: 'northern-rivers',
    timezone: 'Australia/Sydney',
    trackerBaseUrl: 'https://datracker.byron.nsw.gov.au',
    trackerSearchUrl: 'https://datracker.byron.nsw.gov.au/MasterViewUI-External/Home/Search',
    adapters: ['masterview', 'nsw_planning_portal'],
    status: 'active',
  },
  {
    name: 'Ballina Shire Council',
    shortName: 'Ballina',
    selectorLabel: 'Ballina Shire',
    state: 'NSW',
    region: 'northern-rivers',
    timezone: 'Australia/Sydney',
    trackerBaseUrl: 'https://da.ballina.nsw.gov.au',
    trackerSearchUrl: 'https://da.ballina.nsw.gov.au/Home/Search',
    adapters: ['masterview_ballina', 'nsw_planning_portal'],
    status: 'active',
  },
  {
    name: 'Lismore City Council',
    shortName: 'Lismore',
    selectorLabel: 'Lismore City',
    state: 'NSW',
    region: 'northern-rivers',
    timezone: 'Australia/Sydney',
    trackerBaseUrl: 'https://www.lismore-nsw.altitudelg.com',
    trackerSearchUrl: 'https://www.lismore-nsw.altitudelg.com/e-services/daEnquiryInit.do?doc_typ=5&nodeNum=162748',
    adapters: ['altitude_lg', 'nsw_planning_portal'],
    status: 'active',
  },
  {
    name: 'Tweed Shire Council',
    shortName: 'Tweed',
    selectorLabel: 'Tweed Shire',
    state: 'NSW',
    region: 'northern-rivers',
    timezone: 'Australia/Sydney',
    trackerBaseUrl: 'https://datracker.tweed.nsw.gov.au',
    trackerSearchUrl: 'https://www.tweed.nsw.gov.au/development-business/development-applications/da-tracker-property-search',
    adapters: ['xc_track', 'nsw_planning_portal'],
    status: 'active',
  },
  {
    name: 'Coffs Harbour City Council',
    shortName: 'Coffs Harbour',
    selectorLabel: 'Coffs Harbour',
    state: 'NSW',
    region: 'mid-north-coast',
    timezone: 'Australia/Sydney',
    trackerBaseUrl: null,
    trackerSearchUrl: null,
    adapters: ['nsw_planning_portal'],
    status: 'planned',
  },
  {
    name: 'Brisbane City Council',
    shortName: 'Brisbane',
    selectorLabel: 'Brisbane',
    state: 'QLD',
    region: 'brisbane',
    timezone: 'Australia/Brisbane',
    trackerBaseUrl: 'https://developmenti.brisbane.qld.gov.au',
    trackerSearchUrl: 'https://developmenti.brisbane.qld.gov.au',
    adapters: ['development_i'],
    status: 'planned',
  },
];

const STATE_VOCABULARY = {
  NSW: {
    feedTypes: [
      'Development Application',
      'DA Modification',
      'S4.55',
      'S96',
      'Complying Development',
      'Complying Development Cert',
      null,
    ],
    certificateTypes: [
      'Construction Certificate',
      'Occupation Certificate',
      'Section 68',
      'Subdivision Certificate',
    ],
  },
  QLD: {
    feedTypes: ['Material Change of Use', 'Reconfiguring a Lot', 'Building Works', null],
    certificateTypes: [],
  },
};

const byName = new Map(COUNCILS.map(council => [council.name, council]));

function councilByName(name) {
  return byName.get(name);
}

function activeCouncils(region) {
  return COUNCILS.filter(council => council.status === 'active' && (!region || council.region === region));
}

function activeCouncilNames(region) {
  return activeCouncils(region).map(council => council.name);
}

function normaliseCouncilName(name) {
  const value = String(name || '').trim();
  if (!value) return null;
  const lower = value.toLowerCase();
  const match = COUNCILS.find(council => {
    const full = council.name.toLowerCase();
    const short = council.shortName.toLowerCase();
    const selector = council.selectorLabel.toLowerCase();
    return full === lower || short === lower || selector === lower || full.includes(lower);
  });
  return match?.name || value;
}

function shortCouncilName(name) {
  return byName.get(name)?.shortName
    || String(name || 'Unknown').replace(/ (Shire|City)? ?Council$/, '');
}

function councilSelectorLabel(name) {
  return byName.get(name)?.selectorLabel || shortCouncilName(name);
}

function trackerSearchUrls() {
  return Object.fromEntries(
    activeCouncils().map(council => [council.name, council.trackerSearchUrl || council.trackerBaseUrl])
  );
}

export {
  COUNCILS,
  REGIONS,
  STATE_VOCABULARY,
  activeCouncilNames,
  activeCouncils,
  councilByName,
  councilSelectorLabel,
  normaliseCouncilName,
  shortCouncilName,
  trackerSearchUrls,
};
